<div [class]="styleClass" [ngClass]="{
  'app-input-wrapper form-group flex-column': true,
  'input-primary': theme === 'primary',
  'input-secondary': theme === 'secondary',
  'input-light': theme === 'light',
  'input-border': theme === 'border',
  'active': isActive,
  'invalid': isInvalid,
  'warning': isWarning,
  'hover-effect': hasHoverEffect,
  'active-bg': hasBgOnActive,
  'float-label': isActive || value || value?.length > 0,
  'no-border-bottom': !hasBorderBottomOnActive,
  'disabled': disabled,
  'input-icon-left': leftIcon,
  'input-icon-right': rightIcon,
  'input-icon-right-second': rightIconSecond,
  'input-image-icon': imgIcon,
  'input-action-wrapper': hasActions || hasShowPasswordIcon
}" #inputContainer>
  <div class="flex-start-center width-100p" [class]="styleClassContainer" (click)="onClick()">
    <i [class]="leftIcon" [ngClass]="{'left-icon font-gray-65': true}" (click)="onFocus()" *ngIf="leftIcon"></i>
    <input autocomplete="new-name" [id]="id" [patterns]="patterns" [type]="type" [disabled]="disabled"
      [thousandSeparator]="thousandSeparator" [class]="styleClassInput" [readonly]="readOnly"
      [ngClass]="{'disabled': disabled, 'app-input': true, 'app-float-input': floatingLabel, 'input-elipses': showElipses, 'text-right': textAlign === 'right'}"
      [ngStyle]="{fontSize: fontSize + 'px'}" [maxlength]="maxLength" [name]="name" [placeholder]="placeholder"
      [(ngModel)]="value" [mask]="mask" [prefix]="prefix" [suffix]="suffix"
      [dropSpecialCharacters]="dropSpecialCharacters" (focus)="onFocus()" (blur)="onBlur()"
      (keypress)="onKeyPress($event)" (ngModelChange)="onModalChange($event)" (keyup)="onKeyUp($event)" (change)="onInputChange($event)"
      (keydown.enter)="onEnter()" (keydown.tab)="onTabPress()" (paste)="validatePaste($event)" #inputControl >
    <!-- afterDecimal -->
    <img [src]="imgIcon" (click)="iconClicked.emit()" class="imgIcon" [ngClass]="imgIconClass" *ngIf="imgIcon">
    <img [src]="imgIconSecond" (click)="secondIconClicked.emit()" [ngClass]="imgIconClass" class="imgIconSecond" *ngIf="imgIconSecond">
    <i [class]="rightIcon" (click)="iconClicked.emit()" [ngClass]="{'right-icon font-gray-65': true}"
      *ngIf="rightIcon"></i>
    <i [class]="rightIconSecond" (click)="secondIconClicked.emit()" [ngClass]="{'right-icon-sec font-gray-65': true}"
      *ngIf="rightIconSecond"></i>
    <span class="appt-color-circle" *ngIf="colorCircle">
      <span class="color flex-center-center" [ngStyle]="{ 'background-color': colorValue }"></span>
    </span>
    <span class="mr-1" *ngIf="colorCircle && !colorValue">
      <i class="fal fa-question-circle font-18 font-gray-65"></i>
    </span>
    <i [class]="cancelIcon" [ngClass]="{'input-action cancel-icon font-gray-65 pointer': true}"
      *ngIf="isCancelIcon && cancelIcon" (click)="onCancel()"  tooltipPosition="top"
       [pTooltip]="cancelHover"></i>
    <i [class]="saveIcon" [ngClass]="{'input-action save-icon font-gray-65 pointer': true}"
      *ngIf="hasActions && saveIcon" (click)="onSave()"></i>
    <i [class]="(isPasswordHidden)? 'fa-eye': 'fa-eye-slash'"
      [ngClass]="{'fas input-action eye-icon font-gray-65 pointer': true}" *ngIf="hasShowPasswordIcon"
      (click)="toggleHidePassword()"></i>
    <i *ngIf="tooltipIconClass" [class]="tooltipIconClass" [tooltipPosition]="tooltipIconPosition"
    [pTooltip]="tooltipIconText" [tooltipStyleClass]="tooltipStyleClass" (click)="onTooltipIconClicked.emit()"></i>
      <button [class]="styleClassButton" *ngIf="hasShowButton" (click)="handleInputButton()">{{buttonLabel}}</button>
  </div>
  <label [hidden]="!floatingLabel" [class]="styleClassLabel"
    [ngClass]="{'disabled': disabled, 'app-input-label': true, 'app-label-float': floatingLabel}" (click)="onFocus()">
    {{label || placeholder}}
  </label>
  <div [id]="validationId" [ngClass]="{'app-input-error': true}" [class]="styleClassError">
    {{errorMessage}}
  </div>
  <div [id]="validationId" [ngClass]="{'app-input-warning': true}" [class]="styleClassError">
    {{warningMessage}}
  </div>
</div>
